
module.exports = function(app) {
    app.directive('wellnessNeedSomeHelp', function() {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'wellness.appTemplate.html/chmhom/directives/wellnessNeedSomeHelp',
            controller: ['$scope','coremetrics','services','sessionData', function($scope,coremetrics, services,sessionData) {
                    $scope.phoneNumberCoremetrics = function(){
                        coremetrics.elementTag('WebMD Phone Number', 'Member: Wellness');
                    };

                    $scope.coachLinkCoremetrics = function(){
                        coremetrics.elementTag('How coaches can help', 'Member: Wellness');
                    };

                    $scope.miniClass = ($scope.isMINCR ? 'miniHealthCoach' : '');

                    var brand = sessionData && sessionData.memberInfo && sessionData.memberInfo.brand;
                }


            ]
        };
    });
};